import { forwardRef } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

export const withRouter = (Component) => {
  // forwardRef para que um ref colocado no componente embrulhado chegue à
  // instância interna (ex.: ExamesComponent em modoCadastro, que expõe
  // submitPedidoCadastro). Para os demais usos o ref fica null e é inócuo.
  const ComponentWithRouterProp = forwardRef(function ComponentWithRouterProp(props, ref) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    return <Component {...props} ref={ref} router={{ location, navigate, params }} />;
  });
  return ComponentWithRouterProp;
};